"use client";
import { toast } from "@/components/ui/use-toast";
import { useCartStore2 } from "@/stores/cartStore";
import { useRouter } from "next/navigation";
import Countdown from "@/components/ui/countdown/Countdown";

interface PlansProps {
  products: any[];
}

export default function CyberHome({ products }: PlansProps) {
  const router = useRouter();
  const { addItem } = useCartStore2();


  const selectPlan = (product: any) => {
    // Add the selected plan to the cart
    addItem({
      line_type: "subscription",
      product_id: product.id,
      quantity: 1
    });

    // Show toast notification
    toast({
      title: "Plan añadido al carrito",
      description: `Has seleccionado el plan ${product.name}.`,
      duration: 3000,
    });

    // Navigate to payment page
    router.push("/payment");
  };
  return (
    <>
     
      
      {/* Banner Images */}
      <div
        onClick={() => selectPlan(products[0])}
        className="hidden md:block w-full h-[70vh] xl:h-[100vh] h-max-screen bg-[url('https://maluapp.b-cdn.net/resources/cybermalu1.png')] bg-no-repeat bg-cover bg-center cursor-pointer"
      ></div>
      <div
        onClick={() => selectPlan(products[0])}
        className="md:hidden w-full h-[90vh] h-max-screen bg-[url('https://maluapp.b-cdn.net/resources/cybermalu2.png')] bg-no-repeat bg-cover bg-top cursor-pointer"
      ></div>
    </>
  );
}
